import { observable } from 'mobx';
import Model from './Model';


class Substep extends Model {
  static basePath = '/api/substeps';
  static verboseName = 'Substep';

  @observable step;
  @observable step_position;
  @observable name;
  @observable substep_position;
  @observable button_action;
  @observable responsible;
  @observable action;
  @observable url_action;
  @observable checked;

}


export default Substep;
